
import { useContext } from 'react'
import FormInput from '../dashboardComponents/FormInput';
import { DashboardContext } from '../../../contextApi/DashboardContext';
import FormButton from '../dashboardComponents/FormButton';
import { AppContext } from '../../../contextApi/ContextApi';

export default function AddBranchForm({website}) {
  const { setToastMessage, messagesOptions } = useContext(AppContext);
  const {handleAddBranch, branchAddress, setBranchAddress, branchCity, setBranchCity, isAddBranch} = useContext(DashboardContext);

  return (
    <form dir='rtl' className='dashboardForm'>
        <h2>טופס הוספת סניף</h2>
        <FormInput _class={"dashboardForm_section"} hasLabel={true} label={"שם עיר:"} id={"addBranch_city"} _value={branchCity} placeholder={"לדוגמא: חולון"} type={"text"} onChangeAction={(e)=>{setBranchCity(e.target.value)}} required={true}/>
        <FormInput _class={"dashboardForm_section"} hasLabel={true} label={"כתובת:"} id={"addBranch_address"} _value={branchAddress} placeholder={"לדוגמא: התרשיש 3"} type={"text"} onChangeAction={(e)=>{setBranchAddress(e.target.value)}} required={true}/>
        <FormButton disabled={isAddBranch} type={"submit"} text={"הוסף סניף"} action={(e)=>{e.preventDefault(); handleAddBranch(website, setToastMessage, messagesOptions); setBranchAddress(""); setBranchCity("")}} website={website}/>
    </form>
  )
}
